.footer {
  margin-top: 6rem;
  padding: 3rem 4rem 2rem;
  border-top: 1px solid var(--qs-color-line);
}

.footerColumns {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 3rem;
  margin-bottom: 3rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
}

.footerColumn {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.columnHeading {
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--qs-color-text-muted);
  margin: 0;
}

.columnList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.footerLink {
  color: var(--qs-color-text-soft);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color var(--qs-motion-dur-fade) ease;

  &:hover {
    color: var(--qs-color-text);
  }
}

.crossLinks {
  display: flex;
  gap: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--qs-color-line);
  margin-bottom: 0;
}

.crossLink {
  color: var(--qs-color-text-muted);
  text-decoration: none;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  transition: color var(--qs-motion-dur-fade) ease;

  &:hover {
    color: var(--qs-color-text-soft);
  }
}

.crossLinkTagline {
  font-size: 0.7rem;
  opacity: 0.6;
}

.footerBottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid var(--qs-color-line);
}

.footerContact {
  font-size: 0.85rem;
  color: var(--qs-color-text-muted);
}
